import { render, staticRenderFns } from "./TemplatesPicker.vue?vue&type=template&id=50dc936b&scoped=true&"
import script from "./TemplatesPicker.vue?vue&type=script&lang=js&"
export * from "./TemplatesPicker.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesPicker.vue?vue&type=style&index=0&id=50dc936b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc936b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dc936b')) {
      api.createRecord('50dc936b', component.options)
    } else {
      api.reload('50dc936b', component.options)
    }
    module.hot.accept("./TemplatesPicker.vue?vue&type=template&id=50dc936b&scoped=true&", function () {
      api.rerender('50dc936b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/WhatsappTemplates/TemplatesPicker.vue"
export default component.exports